export const VALIDATION_REQUIRED_MESSAGE: string = 'This field is required';
export const VALIDATION_INVALID_EMAIL_MESSAGE: string = 'Please enter a valid email';
export const VALIDATION_MAX_LENGTH_MESSAGE = (field: string): string => `${field} must be shorter than or equal to \${max} characters`;
export const VALIDATION_MATCH_GUEST_ID_MESSAGE: string = 'This field must not match the Guest ID';
export const VALIDATION_MATCH_CLC_REQUEST_MESSAGE: string = 'The Request # cannot match the Reservation ID';
export const VALIDATION_EQUALS_MESSAGE = (field1: string, field2: string): string => `${field1} must not be the same as ${field2}`;
export const VALIDATION_EMAIL_MATCH_REGEX_PATTERN = /@sasrlink.com$/;
export const VALIDATION_IVALID_MATCH_EMAIL_MESSAGE: string = 'Please use an email address ending with "@sasrlink.com"';
export const VALIDATION_DIGITS_PATTERN_MESSAGE = (field: string, digits: number): string => `${field} must be exactly ${digits} digits`;
export const VALIDATION_INVALID_URL_MESSAGE: string = 'Invalid URL';
export const VALIDATION_INVALID_COLOR_MESSAGE: string = 'Invalid hex color';

export enum ReservationStatuses {
  Active = 'Active',
  Inactive = 'Inactive',
  Canceled = 'Canceled',
}

export enum LodgingRequestStatuses {
  Open = 'Open',
  Completed = 'Completed',
  Canceled = 'Canceled',
  Draft = 'Draft',
  Pending = 'Pending'
}

export enum LodgingStatuses {
  Active = 'Active',
  Closed = 'Closed',
}

export enum ReservationTypes {
  Internal = 'Internal',
  External = 'External'
}

export enum GuestListGroups {
  RequestedGuest = 'requested-guest',
  RoommatesOptions = 'roommates-options',
  BookedDraftRoommatesOptions = 'booked-draft-roommates-options',
  DroppedForAssignment = 'dropped-for-assignment',
  SelectedForAssignment = 'selected-for-assignment',
}

export const GuestListGroupHeaderName: ReadonlyMap<string, string> = new Map<string, string>([
  [GuestListGroups.RequestedGuest, 'Requested Guest'],
  [GuestListGroups.RoommatesOptions, 'Roommates Options'],
  [GuestListGroups.BookedDraftRoommatesOptions, 'Booked/Draft Roommates Options'],
  [GuestListGroups.DroppedForAssignment, 'Dropped For Assignment'],
  [GuestListGroups.SelectedForAssignment, 'Selected for Assignment'],
]);

export const GuestListGroupIcon: ReadonlyMap<string, string> = new Map<string, string>([
  [GuestListGroups.RequestedGuest, 'already-assigned'],
  [GuestListGroups.RoommatesOptions, 'none'],
  [GuestListGroups.BookedDraftRoommatesOptions, 'none'],
  [GuestListGroups.DroppedForAssignment, 'none'],
  [GuestListGroups.SelectedForAssignment, 'already-assigned'],
]);

export const GuestListGroupEmpty: ReadonlyMap<string, string> = new Map<string, string>([
  [GuestListGroups.RequestedGuest, 'Already Assigned'],
  [GuestListGroups.RoommatesOptions, 'No Records'],
  [GuestListGroups.BookedDraftRoommatesOptions, 'No Records'],
  [GuestListGroups.DroppedForAssignment, 'No Records'],
  [GuestListGroups.SelectedForAssignment, 'Already Assigned'],
]);

export const GuestListGroupExpandingContainer: ReadonlyMap<string, boolean> = new Map<string, boolean>([
  [GuestListGroups.RequestedGuest, false],
  [GuestListGroups.RoommatesOptions, false],
  [GuestListGroups.BookedDraftRoommatesOptions, true],
  [GuestListGroups.DroppedForAssignment, false],
  [GuestListGroups.SelectedForAssignment, false],
]);

export enum BookingPageHeaders {
  SingleBooking = 'Single Booking',
  MassBooking = 'Mass Booking',
  LodgingsAndReservations = 'Lodgings & Reservations',
}

export enum ReportRoutes {
  Request = "/app/requests/report/",
  Reservation = "/app/reservations/report/",
  OccupancyRate = "/app/occupancy-rate/report/",
  lodgingOption = "/app/lodgings/report/"
}

//ToDo: for refactor: add getMaxRowsCountToReportDownload backend rout and get it VIA API
export const MAX_ROWS_COUNT_TO_REPORT_DOWNLOAD = 100;

export const REPORT_NOT_AVAILABLE_ON_AMAZON_ERROR = 'File download has expired'

export const NOT_LOGIN_REPORT_ERROR = 'Please login to download the file'

export const RESTRICT_CLIENT_CREATION_ON_FORMS = true;